import { useState } from "react";
import { IconButton, CircularProgress } from "@mui/material";
import { Save } from "@mui/icons-material";

const IconButtonSave = ({ onBtnClick, disabled, size = "medium", savingTimeout = 5000, withProcessing = false }) => {
  const [saving, setSaving] = useState(false);
  const handleAction = async () => {
    setSaving(true);
    if (savingTimeout) {
      setTimeout(() => {
        setSaving(false);
      }, savingTimeout);
    }
    await onBtnClick();
    setSaving(false);
  };

  return (
    <>
      {(saving && withProcessing) ? <CircularProgress size={size === "large" ? 25 : size === "medium" ? 20 : 15} /> : (
        <IconButton onClick={() => handleAction()} disabled={disabled} size={size}>
          <Save fontSize="inherit" />
        </IconButton>
      )}
    </>
  );
};

export default IconButtonSave;
